// import { Models } from '@/main';
export class InstanceLoader {
    static get(className, ...args) {
        // if (Models[className] === undefined || Models[className] === null) {
        //   `Class type of \'${className}\' has not been added to the InstanceLoader.`;
        //   throw new Error();
        // }
        return new (require('@/models/' + className)[className])(...args);
        // return new Models[className](...args);
    }
}
